import { backgroundSecondaryColor, inputLabels, darkPalette } from "../palette";

export const MuiOutlinedInput = {
  MuiOutlinedInput: {
    root: {
      backgroundColor: backgroundSecondaryColor + "!important",
      "&.Mui-disabled": {
        "& > fieldset": {
          borderColor: darkPalette.grey[600] + " !important",
        },
      },
    },
    notchedOutline: {
      borderColor: "#fafafa",
    },
  },
  MuiInputLabel: {
    root: {
      color: inputLabels,
    },
  },
};
